import { render, staticRenderFns } from "./PromoLinksComponent.vue?vue&type=template&id=206ee4f7"
import script from "./PromoLinksComponent.vue?vue&type=script&lang=js"
export * from "./PromoLinksComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports